module.exports = __webpack_public_path__ + "static/media/google.5732b5da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/checkout-success-step/google.png
// module id = 650
// module chunks = 0